import { render, staticRenderFns } from "./GplTab.vue?vue&type=template&id=b1498696&"
import script from "./GplTab.vue?vue&type=script&lang=js&"
export * from "./GplTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports